import { useState, useCallback, useMemo, useEffect } from "react"
import classnames from "classnames"
import { Divider, Tabs } from "@mui/material"
import { TABS_PROPS } from "../shapes"
import { ACTIONS } from "../constants"
import SummaryTab from "./summary-tab"
import Summary from "./summary"

const { SIMULATOR_SUMMARY, ANALYZE_FACTORS_SUMMARY, FACTOR_SUMMARY, SECURITY_SUMMARY } = ACTIONS

export default function AISummaryTabs({ summaryButtons, setShowDateRange, summaryStates, setCurrentSummaryAction, resource, base }) {
  const tabs = useMemo(() => [
    {
      label: "Trade Ideas",
      value: SIMULATOR_SUMMARY,
      state: summaryStates[SIMULATOR_SUMMARY],
    },
    {
      label: "Asset Summary",
      value: SECURITY_SUMMARY,
      state: summaryStates[SECURITY_SUMMARY],
    },
    {
      label: "Factor Trends",
      value: ANALYZE_FACTORS_SUMMARY,
      state: summaryStates[ANALYZE_FACTORS_SUMMARY],
    },
    {
      label: "Factor Bets",
      value: FACTOR_SUMMARY,
      state: summaryStates[FACTOR_SUMMARY],
    },
  ], [summaryStates])

  const [activeTab, setActiveTab] = useState(0)

  useEffect(() => {
    setShowDateRange(prev => {
      const showDateRange = tabs[activeTab].value !== SIMULATOR_SUMMARY
      if (prev !== showDateRange) {
        return showDateRange
      }
      return prev
    })
  }, [activeTab, setShowDateRange, tabs])

  useEffect(() => {
    setCurrentSummaryAction(tabs[activeTab].value)
  }, [tabs, activeTab, setCurrentSummaryAction])

  const handleChange = useCallback((newValue, action) => {
    setActiveTab(newValue)
    setShowDateRange(action !== SIMULATOR_SUMMARY)
    setCurrentSummaryAction(action)
  }, [setShowDateRange, setCurrentSummaryAction])

  return <>
    <div className={classnames("ai-summary-tabs-sticky", { active: !!base })}>
      <Tabs value={activeTab} className="ai-summary-tabs" variant="scrollable" scrollButtons="auto">
        {tabs.map(({ label, value, state }, index) => <SummaryTab
          key={`${value}-${index}-tab`}
          label={label}
          action={value}
          activeTab={activeTab}
          handleChange={handleChange}
          index={index}
          summaryState={state}
          resource={resource}
        />)}
      </Tabs>
      <Divider />
    </div>
    <div>
      {tabs.map(({ value, state }, index) => {
        const { summary, error, timestamp } = state || {}
        const isGenerated = Boolean(timestamp && summary)
        const showSummary = activeTab === index

        return showSummary && <Summary
          key={`${value}-${index}-summary`}
          className={classnames("with-tabs", { active: !!base })}
          summary={summary}
          error={error}
          summaryButtons={summaryButtons}
          isGeneratedByAI={value !== ACTIONS.SIMULATOR_SUMMARY}
          isGenerated={isGenerated}
        />
      })}
    </div>
  </>
}

AISummaryTabs.propTypes = TABS_PROPS
